<div class='demo-app row d-dlex justify-content-center'>
  <div class='demo-app-sidebar col-3'>
    <div *ngIf="!onMarketPage && admin" class='demo-app-sidebar-section'>
      <h2>Navodila</h2>
      <ul>
        <li>Izberite datume in pozvani boste k ustvarjanju novega dogodka</li>
        <li>Vleci, spusti in spreminjaj dolžino dogodkov</li>
        <li>Kliknite na dogodek, da ga izbrišete</li>
      </ul> 
    </div>
    
    <div *ngIf="!onMarketPage && admin" class='demo-app-sidebar-section'>
      <h2>Izberi barvo dogodka</h2>
      <ul>
        <li>Pred ustvarjanjem novega dogodka izberi željeno barvo</li>
      </ul>
      <div class="color-picker">
        <div
          *ngFor="let color of colors"
          [style.background]="color"
          (click)="selectedColor.set(color)"
          class="color-option"
          [class.selected]="color === selectedColor()"
        ></div>
      </div>
    </div>

    <div *ngIf="onMarketPage || !admin" class="demo-app-sidebar-section">
      <h2>Navodila</h2>
      <ul>
        <li>Kliknite na dogodek, za dodatne informacije</li>
      </ul>
    </div>
    
    <div *ngIf="currentEvents().length > 0" class='demo-app-sidebar-section'>
      <h2 (click)="handleDivClick()" class="click">Vsi dogodki ({{currentEvents().length}})</h2>
      <ul>
        <!-- Display the first event or up to 10 events based on the page type -->
        <li *ngFor="let event of (onMarketPage ? currentEvents().slice(0, 10) : [currentEvents()[0]])">
          <b>{{ event.startStr | date: 'dd-MM-yyyy HH:mm' }}</b>
          <i>{{ event.title }}</i>
        </li>
        
        <!-- Display dots if there are more than 10 events -->
        <li *ngIf="currentEvents().length > 10" class="more-events">
          <span (click)="handleDivClick()" class="click">...Preglej vse</span>
        </li>
      </ul>
    </div>
    <div *ngIf="currentEvents().length == 0 && onMarketPage" class='demo-app-sidebar-section'>
      <h2>Na žalost ni dogodkov, lahko jih ustvarite s svojim profilom.</h2>
    </div>
  </div>

  <div class='demo-app-main col-9'>
    <div *ngIf="smallScreen" class="calendar-nav">
      <div class="left-buttons">
        <button mat-raised-button (click)="customPrevDay()">Nazaj</button>
        <button mat-raised-button (click)="customToday()">Danes</button>
        <button mat-raised-button (click)="customNextDay()">Naprej</button>
      </div>
      <div class="right-buttons">
        <button mat-raised-button (click)="customMonthView()">Mesec</button>
        <button mat-raised-button (click)="customWeekView()">Teden</button>
        <button mat-raised-button (click)="customDayView()">Dan</button>
        <button mat-raised-button (click)="customListView()">Dnevni red</button>
      </div>
    </div>    
    <full-calendar *ngIf='calendarVisible()' [options]='calendarOptions()' #calendar>
      
      <ng-template #eventContent let-arg>
        <b>{{ arg.timeText }}</b>
        <i>{{ arg.event.title }}</i>
      </ng-template>
    </full-calendar >
  </div>
</div>